import React from 'react';

import { Select } from '@interlayer/js/components/common/Fields/Select/Select';

import { useTranslations } from '@core/js/hooks/i18n';

import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';

import { TSelectRegProps } from './types';

export const SelectReg: React.FC<TSelectRegProps> = ({
    name,
    options,
    labelKey = name
}) => {
    const t = useTranslations('playtech.mobile.system.registration.label.');
    const { config: { showSuccessTickIcons } } = useRegistrationSelector();

    return (
        <Select
            name={name}
            options={options}
            isValidationIcon={showSuccessTickIcons}
            placeholder={t(labelKey)}
        />
    );
};
